function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function conditionRefsVariable(condition, name, bracketRe) {
  if (!condition) return false;
  if (condition.variable === name && condition.variable !== "__show_once__") return true;
  if (condition.operator === "eval" && typeof condition.value === "string") {
    return bracketRe.test(condition.value);
  }
  return false;
}

// Finds every card that references a variable at runtime: as a condition
// operand, as an operator-card assignment target, or via [VarName]
// interpolation inside an eval expression or paragraph body text.
// Returns a de-duplicated, order-stable list of { story, card } hits.
export function findVariableUsages(storyData, name) {
  const hits = [];
  if (!storyData?.stories) return hits;

  const bracketRe = new RegExp("\\[" + escapeRegExp(name) + "\\]");
  const seen = new Set();

  for (const [storyId, story] of Object.entries(storyData.stories)) {
    for (const [cardId, card] of Object.entries(story.cards || {})) {
      let used = false;

      for (const paragraph of card.paragraphs || []) {
        if ((paragraph.conditions || []).some((c) => conditionRefsVariable(c, name, bracketRe))) {
          used = true;
        }
        const locEntry = storyData.loc?.[paragraph.text];
        if (locEntry) {
          for (const lang of Object.keys(locEntry)) {
            if (bracketRe.test(locEntry[lang] || "")) used = true;
          }
        }
      }

      for (const link of card.links || []) {
        if ((link.conditions || []).some((c) => conditionRefsVariable(c, name, bracketRe))) {
          used = true;
        }
        for (const operation of link.operations || []) {
          if (operation.variable === name) used = true;
          if (operation.operator === "eval" && typeof operation.value === "string" && bracketRe.test(operation.value)) {
            used = true;
          }
        }
      }

      if (used) {
        const key = storyId + "::" + cardId;
        if (!seen.has(key)) {
          seen.add(key);
          hits.push({ story: storyId, card: cardId });
        }
      }
    }
  }

  return hits;
}
